<template>
  <div>
    <v-card elevation="" rounded="lg" class="mb-3" flat>
      <v-card-text class="pa-2">
        <v-btn-toggle
          v-model="activeTab"
          mandatory
          variant="flat"
          color="primary"
          class="button-toggle"
          density="compact"
          divided
        >
          <v-btn value="bmstemplate" size="small" class="text-primary">
            <v-icon
              icon="mdi-format-list-bulleted"
              size="18"
              class="mr-1"
            ></v-icon>
            Templates
          </v-btn>
          <v-btn value="bmscategory" size="small" class="text-primary">
            <v-icon icon="mdi-pill" size="18" class="mr-1"></v-icon>
            Category
          </v-btn>
         
        </v-btn-toggle>
      </v-card-text>
    </v-card>

    <v-window v-model="activeTab">
      <v-window-item value="bmscategory">
        <Category ref="categoryCard" />
      </v-window-item>
      <v-window-item value="bmstemplate">
        <Templates ref="templateCard" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import Category from "@/views/ChildPages/Category.vue";
import Templates from "@/views/ChildPages/Templates.vue";

export default {
  name: "MedicationPage",
  components: { Category, Templates },
  data() {
    return {
      activeTab: "bmstemplate",
    };
  },
  watch: {
    activeTab(newVal) {
      if (newVal === "bmscategory" && this.$refs.categoryCard?.onTabActivated) {
        this.$refs.categoryCard.onTabActivated();
      }
      if (newVal === "bmstemplate" && this.$refs.templateCard?.onTabActivated) {
        this.$refs.templateCard.onTabActivated();
      }
    },
  },
};
</script>
<style scoped>
.button-toggle :deep(.v-btn) {
  min-width: 140px;
  font-weight: 500;
  text-transform: capitalize;
  font-size: 0.875rem;
}

.button-toggle :deep(.v-btn--active) {
  color: white !important;
}

.button-toggle :deep(.v-btn--active .v-icon) {
  color: white !important;
}
</style>